import { NavLink, Outlet } from 'react-router-dom';
import { BasePathProvider } from '../lib/basePath';

// Tab-bar wrapper that hosts the seller's self-service area at /workspace/*.
// The actual content (products / prices / schedules / profile) is rendered
// via <Outlet/> from nested routes in App.tsx — we just provide a stable
// sub-navigation so the seller has one obvious home base.
//
// BasePathProvider("/workspace") tells the reused pages (ProductsList,
// PriceImports, ...) to build links under our prefix instead of '/' so
// "Edit product" stays inside the workspace.
export default function Workspace() {
  return (
    <BasePathProvider value="/workspace">
      <div className="container">
        <div className="workspace-tabs">
          <NavLink to="/workspace/profile" end>Профиль</NavLink>
          <NavLink to="/workspace/products">Товары</NavLink>
          <NavLink to="/workspace/prices" end={false}>Прайсы</NavLink>
          <NavLink to="/workspace/schedules">Расписания</NavLink>
        </div>
        <div className="workspace-body">
          <Outlet />
        </div>
      </div>
    </BasePathProvider>
  );
}
